import { useToastContext } from 'core/components/Toast/context/ToastContext';
import React, { useState } from 'react';

import * as yup from 'yup';

interface ResetPasswordModalProps {
	closeModal: () => void;
	onResetPassword: (email: string, tenant: string) => Promise<void>;
}

export default function ResetPasswordModal({ closeModal, onResetPassword }: ResetPasswordModalProps): JSX.Element {
	const [email, setEmail] = useState('');
	const [tenant, setTenant] = useState(localStorage.getItem('BYOD-organizationId') || '');
	const { showToast } = useToastContext();

	const [isLoading, setIsLoading] = useState(false);

	const schema = yup.object().shape({
		email: yup.string().email(),
		tenant: yup.string().required(),
	});

	const handleResetPassword = async () => {
		try {
			setIsLoading(true);
			const isValid = await schema.isValid({ email, tenant });
			
			if (isValid) {
				// Convert email to lowercase before sending to API (with null check)
				await onResetPassword(email ? email.toLowerCase().trim() : '', tenant);
				showToast('success', 'Check your email for password reset instructions!');
				closeModal();
			} else {
				showToast('error', 'Please enter a valid email and Organization ID');
			}
		} catch (error) {
			showToast('error', 'Something went wrong!');
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="FormResetPassword">
			<span>Enter your Organization ID and email to reset your password.</span>
			<input
				className="InputContent"
				placeholder="Organization ID"
				value={tenant}
				onChange={(e) => setTenant(e.target.value)}
			/>
			<input
				className="InputContent"
				autoFocus
				placeholder="example@domain.com"
				value={email}
				onChange={(e) => setEmail(e.target.value)}
				style={{ marginBottom: '10px' }}
			/>
			<div
				style={{
					display: 'flex',
					justifyContent: 'flex-end',
					marginTop: '20px'
				}}
			>
				<button
					style={{
						backgroundColor: !email.trim() || !tenant.trim() ? 'gray' : '#446388',
					}}
					onClick={handleResetPassword}
					disabled={isLoading || !email.trim() || !tenant.trim()}
				>
					{isLoading ? 'Sending...' : 'Send'}
				</button>
			</div>
		</div>
	);
}
